<template>
  <form action="">
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">Workout on {{date}}</p>
      </header>

      <section class="modal-card-body" style="padding:0px">
        <div class="" style="border-bottom:1px solid #DDD " v-if="obj">
          <header class="card-header">
            <p class="card-header-title">
              {{obj.time}} </p>
            <div class="card-header-icon" aria-label="more options">
              <span class="tag is-rounded is-outlined is-medium">{{obj.nbr_rounds}} Rounds </span>
            </div>
          </header>
          <div class="card-content">
            <div class="media">
              <div class="media-left">
                <figure class="image is-48x48">
                  <img :src="obj.pic" alt="Placeholder image" style="border-radius:100%">
                </figure>
              </div>
              <div class="media-content ">
                <p class="title is-5">{{obj.title}}</p>
                <p class="subtitle is-6">with {{obj.trainer}}</p>
              </div>
            </div>
          </div>
        </div>
        <div style="padding:20px" v-if="!isSubmitted">
          <b-field label="Name">
            <b-input type="text" name="fullname" v-model="name" placeholder="Name" required>
            </b-input>
          </b-field>
          <b-field label="Email">
            <b-input type="email" name="email" v-model="email" placeholder="Your Email" required>
            </b-input>
          </b-field>
          <b-field label="Phone Number">
            <b-input type="tel" name="phone" autocomplete="tel" v-model="phonenumber" placeholder="Your Phone Number" required></b-input>
          </b-field>
        </div>
        <div style="padding:20px" v-else>
          <p class="title is-5">{{content.success_title}}</p>
          <p>{{content.success_text}}</p>
        </div>
      </section>

      <footer class="modal-card-foot" v-if="!isSubmitted">
        <button class="button" type="button" @click="$parent.close()">Cancel</button>
        <button class="button is-danger" type="button" v-on:click="submitInfo()" :disabled="!validated">Book</button>
      </footer>
      <footer class="modal-card-foot" v-else>
        <button class="button is-danger" type="button" @click="$parent.close()">Ok</button>
      </footer>
    </div>
    <b-loading :is-full-page="false" :active.sync="isLoading" :can-cancel="false"></b-loading>
  </form>
</template>

<script>
  import Airtable from 'airtable'

  Airtable.configure({
    endpointUrl: 'https://api.airtable.com',
    apiKey: 'keyrdyLJ8xDPb6CZL'
  });


  var base = Airtable.base('app5JVWpQ8s5kYHcW');
  export default {
    name: 'Form',
    props: ['date', 'obj', 'table', 'content'],
    data() {
      return {
        isLoading: false,
        isSubmitted: false,
        validated: false,
        phonenumber: "",
        email: "",
        name: "",
      }
    },
    methods: {
      submitInfo() {
        this.isLoading = true;
        Promise.resolve().then(() => {
          return base(this.table).create({
            "Name": this.name,
            "Email": this.email,
            "PhoneNumber": this.phonenumber,
            "Time Slot": (this.obj)? this.obj.time: null,
          })
        }).then(() => {
          this.$ga.event('WorkoutBookingSuccessful', 'Success', this.table );
          window.fbq('track', 'Lead');
          this.isSubmitted = true;
            this.$toast.open({
            duration: 5000,
            message: this.content.success_toast,
            position: 'is-bottom',
            type: 'is-success'
          })
        }).catch(() => {
          this.$ga.event('WorkoutBookingFailed', 'Success', this.table );
          this.$toast.open({
            duration: 5000,
            message: this.content.fail_toast,
            position: 'is-bottom',
            type: 'is-danger'
          })
        }).then(() => {
          this.isLoading = false;
        });
      },
      validate() {
        if (this.name && this.email && this.phonenumber) {
          this.validated = true;
        } else {
          this.validated = false;
        }
      }
    },
    watch: {
      name: function () {
        this.validate();
      },
      email: function () {
        this.validate();
      },
      phonenumber: function () {
        this.validate();
      }
    }
  }
</script>

<style scoped>
  .bottom-content {
    display: flex;
    justify-content: space-between;
  }

  .card-header {
    background-color: #EEE
  }

  .is-outlined {
    border: 1px solid rgb(74, 74, 74);

  }

  .remove-margin {
    margin-right: -20px;
    margin-left: -20px
  }
</style>